// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"e6889d3c","552":"a1a45a09","815":"d62b4755","834":"d692d534"}[chunkId] + ".chunk.js";
};